import assetManager from 'AssetManager';
import { getState } from 'pluginServices/store';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import { ICON_LIBRARY_LIST, ICON_LIBRARY_STATUS } from 'containers/IconLibraryManager/IconLibrarySelector/constants';
import activityService from 'services/ActivityService';
import { INTERACTIVE } from 'services/ActivityService/elementTypes';
class AssetServices {
  constructor({ context, id }) {
    this.context = context;
    this.id = id;
  }


  provisionUpload() {
    //just for testing pipeline
    return assetManager.provisionUpload();
  }

  getSubscription() {
    const { subscriptionId } = selectCurrentMe(getState());
    return subscriptionId;
  }

  informAssetUsage(id, coursewareType, urn) {
    return assetManager.informAssetUsage(id, coursewareType, urn);
  }

  resolveAsset(urn) {
    return assetManager.resolveAsset(urn);
  }

  removeLinkedAsset(msg) {
    const assetRemove = async (msg) => {
      const { urn } = msg.data;
      return await assetManager.removeFile(this.id, INTERACTIVE)(urn);
    };
    assetRemove(msg);
  }

  getIconAssetList = async () => {
    const activityId = await activityService.getRootActivityId(this.id);

    const {
      activityThemeIconLibraries = ICON_LIBRARY_LIST,
    } = await activityService.getActivity(activityId, true);

    const selectedIconLibraries = activityThemeIconLibraries
      .filter((iconLibrary) => iconLibrary.status === ICON_LIBRARY_STATUS.SELECTED)
      .map((iconLibrary) => iconLibrary.name);

    return selectedIconLibraries.length ? assetManager.getIconAssetList(selectedIconLibraries) : [];
  }

  static build(args) {
    return new AssetServices(args);
  }
}

export default AssetServices;
